// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8543702b","239":"335e9d0c","453":"0f53a658","455":"27cb0f0f"}[chunkId] + ".chunk.js";
};